import React, { useContext } from 'react';

import AbTestBranch from 'components/ab-test-branch/ab-test-branch';
import { Variation } from 'components/ab-test/ab-test';
import Navbar from 'components/navbar/navbar';
import NavbarNew from 'components/navbar/navbar-new';
import LayoutContext from 'contexts/layoutContext';
import { useMenuMainNavLinks, useMenuTopNavigation } from 'hooks/use-menu';
import { MenuLink } from 'types/types';

interface Props {
  overwriteMenu?: MenuLink[];
  menu?: MenuLink[];
  scrollDistance?: number;
  isDiscovery?: boolean;
  hideSignUpButton?: boolean;
  isVisio?: boolean;
}

const NavSwapAbTest = ({
  overwriteMenu,
  scrollDistance,
  isDiscovery,
  hideSignUpButton,
  isVisio
}: Props) => {
  const {
    language: { langPrefix }
  } = useContext(LayoutContext);

  const oldNavbarMenu = useMenuMainNavLinks(langPrefix);
  const newNavbarMenu = useMenuTopNavigation(langPrefix);

  return (
    <>
      <AbTestBranch branch={Variation.A}>
        <Navbar
          hideSignUpButton={hideSignUpButton}
          isDiscovery={isDiscovery}
          isVisio={isVisio}
          menu={overwriteMenu || oldNavbarMenu}
          scrollDistance={scrollDistance || 1}
        />
      </AbTestBranch>
      <AbTestBranch branch={Variation.B}>
        <NavbarNew
          hideSignUpButton={hideSignUpButton}
          isDiscovery={isDiscovery}
          isVisio={isVisio}
          menu={overwriteMenu || newNavbarMenu}
          scrollDistance={scrollDistance || 1}
        />
      </AbTestBranch>
    </>
  );
};

export default NavSwapAbTest;
